// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'vr-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    d='M6.15 4.498a30.618 30.618 0 0 1 5.7 0l.955.09a4.457 4.457 0 0 1 4.043 4.437v.66a3.56 3.56 0 0 1-2.497 3.397 3.957 3.957 0 0 1-3.874-.876l-.713-.663a1.12 1.12 0 0 0-1.526.003l-.694.648a3.964 3.964 0 0 1-3.886.888 3.568 3.568 0 0 1-2.506-3.405v-.654c0-2.3 1.752-4.221 4.041-4.435zm5.482 1.06a28.017 28.017 0 0 0-5.265 0l-1.172.11a1.001 1.001 0 0 0 .189 1.992l1.173-.111a26.012 26.012 0 0 1 4.887 0l1.172.11a1 1 0 0 0 1.088-.9l.005-.103a1.002 1.002 0 0 0-.906-.987z'
  />
);

export const viewBox = '0 0 18 18';
